export const DATE_TIME_SCHEDULER = {
  format: "MM/dd/yyyy",
  minTime: 0,
  maxHrs: 23,
  maxMinutes: 59
}